import * as StellarSdk from '@stellar/stellar-sdk';

export function getErrorMessage(error: unknown): string | undefined {
    if (typeof error === 'string') {
        return error;
    }
    return (error as { message?: string })?.message;
}

export function getTxSentryExtra(tx: StellarSdk.Transaction, error?: unknown) {
    return {
        errorMessage: getErrorMessage(error),
        fee: tx.fee,
        operationTypes: tx.operations.map(({ type }) => type),
        source: tx.source,
    };
}
